import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../api/api-response';
import { RegraProcedimento, SalvarRegraPayload } from './regra-procedimento.model';

@Injectable({ providedIn: 'root' })
export class RegraProcedimentoService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Cupom`;

  listar(nrSeqCupom: number): Observable<ApiResponse<RegraProcedimento[]>> {
    return this.http.get<ApiResponse<RegraProcedimento[]>>(`${this.url}/${nrSeqCupom}/regra-procedimento`);
  }

  criar(nrSeqCupom: number, payload: SalvarRegraPayload): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(`${this.url}/${nrSeqCupom}/regra-procedimento`, payload);
  }

  excluir(nrSequencia: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.url}/regra-procedimento/${nrSequencia}`);
  }
}
